module.exports = __webpack_public_path__ + "static/media/fire@2x.853543d3.png";